"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeExchange = exports.loadExchangeInfo = exports.makeExchangeInfo = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const constants_1 = require("../constants");
const account_1 = require("../util/account");
/**
 * Creates an IExchangeInfo from parameters.
 * @returns
 */
const makeExchangeInfo = ({ exchange, swap, accounts, }) => {
    const swapAmountA = (0, token_utils_1.deserializeAccount)(swap.state.tokenA.reserve, accounts.reserveA).amount;
    const swapAmountB = (0, token_utils_1.deserializeAccount)(swap.state.tokenA.reserve, accounts.reserveB).amount;
    const poolMintSupply = accounts.poolMint
        ? (0, token_utils_1.deserializeMint)(accounts.poolMint).supply
        : undefined;
    return {
        // TODO(igm): this should be calculated dynamically
        ampFactor: (0, token_utils_1.parseBigintIsh)(swap.state.targetAmpFactor.toString()),
        fees: swap.state.fees,
        lpTotalSupply: new token_utils_1.TokenAmount(exchange.lpToken, poolMintSupply !== null && poolMintSupply !== void 0 ? poolMintSupply : 0),
        reserves: [
            {
                reserveAccount: swap.state.tokenA.reserve,
                adminFeeAccount: swap.state.tokenA.adminFeeAccount,
                amount: new token_utils_1.TokenAmount(exchange.tokens[0], swapAmountA),
            },
            {
                reserveAccount: swap.state.tokenB.reserve,
                adminFeeAccount: swap.state.tokenB.adminFeeAccount,
                amount: new token_utils_1.TokenAmount(exchange.tokens[1], swapAmountB),
            },
        ],
    };
};
exports.makeExchangeInfo = makeExchangeInfo;
/**
 * Loads exchange info.
 * @param exchange
 * @param swap
 * @returns
 */
const loadExchangeInfo = (connection, exchange, swap) => __awaiter(void 0, void 0, void 0, function* () {
    if (!exchange.programID.equals(swap.config.swapProgramID)) {
        throw new Error("Swap program id mismatch");
    }
    const reserveA = yield (0, account_1.loadProgramAccount)(connection, swap.state.tokenA.reserve, swap.config.tokenProgramID);
    const reserveB = yield (0, account_1.loadProgramAccount)(connection, swap.state.tokenB.reserve, swap.config.tokenProgramID);
    const poolMint = yield (0, account_1.loadProgramAccount)(connection, swap.state.poolTokenMint, swap.config.tokenProgramID);
    return (0, exports.makeExchangeInfo)({
        swap,
        exchange,
        accounts: {
            reserveA,
            reserveB,
            poolMint,
        },
    });
});
exports.loadExchangeInfo = loadExchangeInfo;
/**
 * Creates an IExchange from an ExchangeBasic.
 * @param tokenMap
 * @param param1
 * @returns
 */
const makeExchange = ({ swapAccount, lpToken, tokenA, tokenB, }) => {
    const exchange = {
        swapAccount,
        programID: constants_1.SWAP_PROGRAM_ID,
        lpToken: new token_utils_1.Token({
            symbol: "SLP",
            name: `${tokenA.symbol}-${tokenB.symbol} Saber LP`,
            logoURI: "https://app.saber.so/tokens/slp.png",
            decimals: tokenA.decimals,
            address: lpToken.toString(),
            chainId: tokenA.chainId,
            tags: ["saber-stableswap-lp"],
        }),
        tokens: [new token_utils_1.Token(tokenA), new token_utils_1.Token(tokenB)],
    };
    return exchange;
};
exports.makeExchange = makeExchange;
//# sourceMappingURL=exchange.js.map